(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vf-card-billets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vf-card-billet-picker')) {
    customElements.define('vf-card-billet-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.billetSelect = this.querySelector('[data-vf-billet-select]');
        this.alloySelect = this.querySelector('[data-vf-alloy-select]');
        this.productLink = this.querySelector('[data-vf-product-link]');
        if (!this.billetSelect?.options.length) return;
        this.initialized = true;
        this.billets = Array.from(this.billetSelect.options, (option) => ({
          id: option.value,
          alloy: option.dataset.vfAlloy,
          label: option.textContent.trim()
        }));
        this.alloys = [...new Set(this.billets.map((billet) => billet.alloy))];
        this.alloySelect.replaceChildren(...this.alloys.map((alloy) => new Option(alloy, alloy)));
        this.alloySelect.value = this.alloys.find((alloy) => /stainless/i.test(alloy)) || this.alloys[0];
        this.renderBillets();
        this.alloySelect.addEventListener('change', () => this.renderBillets());
        this.billetSelect.addEventListener('change', () => {
          const selected = this.billets.find((billet) => billet.id === this.billetSelect.value);
          if (!selected) return;
          this.alloySelect.value = selected.alloy;
          this.renderBillets(selected.id);
        });
      }

      renderBillets(selectedId) {
        const preferredAlloy = this.alloySelect.value;
        const orderedAlloys = [preferredAlloy, ...this.alloys.filter((alloy) => alloy !== preferredAlloy)];
        const fragment = document.createDocumentFragment();
        orderedAlloys.forEach((alloy) => {
          const group = this.alloys.length > 1 ? document.createElement('optgroup') : fragment;
          if (group !== fragment) group.label = alloy;
          this.billets.filter((billet) => billet.alloy === alloy).forEach((billet) => {
            const option = new Option(billet.label, billet.id);
            option.dataset.vfAlloy = alloy;
            group.append(option);
          });
          if (group !== fragment) fragment.append(group);
        });
        this.billetSelect.replaceChildren(fragment);
        if (selectedId) this.billetSelect.value = selectedId;
        const url = new URL(this.productLink.href);
        url.searchParams.set('variant', this.billetSelect.value);
        this.productLink.href = url.toString();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
